<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'text'">
      <input type="text" class="input-text readonly" placeholder readonly />
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="p-0">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepText",
  mixins: [activityStepCustomMessage],
  components: {
    quillEditor
  },
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  data() {
    return {
      isAddHelpEnabled: false
    };
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      if (this.question.characterLimited) {
        if (this.question.textLimit == null || this.question.textLimit.length == 0) {
          const isValid = false;
          const msg = "Character limit is required.";
          const errorObj = { isValid, msg };
          return errorObj;
        }
      }
      if (this.question.isAddHelpEnabled && (!this.question.hasOwnProperty("helpContent") || this.stripHtml(this.question.helpContent).trim() === "")) {
        const isValid = false;
        const msg = "Help text is required for this step.";
        const errorObj = { isValid, msg };
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      return {
        isValid: Boolean((this.question.formattedBody && this.question.sequence && !this.question.characterLimited) || (this.question.formattedBody && this.question.sequence && this.question.characterLimited && this.question.textLimit && this.question.textLimit > 0))
      };
      // break;
    }
  }
};
</script>

<style scoped lang="scss">
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}

.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -38px;

  &.right-position {
    right: 637px;
  }
}
</style>
